import React from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import CustomCommonTooltip from "@/shared/components/ui/Upload/ToolTip/CustomCommonTooltip";

const cn = (...inputs) => twMerge(clsx(inputs));

/**
 * Pill-shaped action, e.g. inserting a token into a field. keepFocus stops the click from
 * stealing focus/selection from the field being edited.
 */
const ChipButton = ({ children, onClick, tooltip, keepFocus = false, disabled = false, className }) => {
  const chip = (
    <button
      type="button"
      disabled={disabled}
      onMouseDown={keepFocus ? (event) => event.preventDefault() : undefined}
      onClick={onClick}
      className={cn(
        "rounded-full border border-gray-200 dark:border-gray-700 px-2.5 py-0.5 text-[0.7rem] font-medium text-gray-700 dark:text-gray-200 transition-colors hover:border-secondary hover:text-secondary disabled:cursor-not-allowed disabled:opacity-60",
        className,
      )}
    >
      {children}
    </button>
  );
  return tooltip ? <CustomCommonTooltip content={tooltip}>{chip}</CustomCommonTooltip> : chip;
};

export default ChipButton;
